// API Configuration - Environment-based URLs
const getApiBaseUrl = () => {
  // Check for explicit environment variable first
  if (process.env.REACT_APP_API_URL) {
    console.log('🔧 Using REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
    console.log('⚠️ WARNING: Using environment variable override. Ensure this URL is correct!');
    return process.env.REACT_APP_API_URL;
  }
  
  // Auto-detect based on current domain
  const hostname = window.location.hostname;
  console.log('🌐 Current hostname:', hostname);
  console.log('🌐 Current protocol:', window.location.protocol);
  console.log('🌐 Current host:', window.location.host);
  
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    // Local development
    const url = 'http://localhost:5000/api';
    console.log('🏠 Using local API:', url);
    return url;
  } else {
    // Production/Staging: Use same domain as frontend (backend serves frontend)
    const url = `${window.location.protocol}//${window.location.host}/api`;
    console.log('☁️ Using same-domain API URL:', url);
    console.log('✅ This should work since backend serves frontend from same domain');
    return url;
  }
};

export const API_BASE_URL = getApiBaseUrl();
console.log('✅ Final API_BASE_URL:', API_BASE_URL);
console.log('📍 If this URL is wrong, check REACT_APP_API_URL environment variable');
export const API_ENDPOINTS = {
  auth: `${API_BASE_URL}/auth`,
  vendors: `${API_BASE_URL}/vendors`,
  weather: `${API_BASE_URL}/weather`,
  health: `${API_BASE_URL}/health`
};
